import { render } from "./brokerage-banner.vue?vue&type=template&id=0f354485"
import script from "./brokerage-banner.js?vue&type=script&lang=js"
export * from "./brokerage-banner.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__